import React from 'react';
import IconTooltipButton from '../../../../button/IconTooltipButton';

const ButtonGenerateXML = ({ loading, id, onClick }) => {
  return (
    <IconTooltipButton
      id={id}
      disabled={loading}
      title='Generate PRS212 XML'
      icon={['fas', 'file-xml']}
      color='secondary'
      style={{
        borderRadius: '0.5rem',
        color: 'var(--secondary)',
        backgroundColor: 'var(--secondary-foreground)',
        padding: '0.45rem',
        opacity: loading ? 0.5 : 1
      }}
      className='shadow-sm'
      onClick={onClick}
    />
  );
};

export default ButtonGenerateXML;
